import { queryOptions } from "@tanstack/react-query";
import { getQueryOptions } from "../../../../lib/api";

export const getGroupQueryOptions = ({
  testId,
  groupId,
}: {
  testId: string | undefined;
  groupId: string;
}) => {
  return queryOptions({
    enabled: !!testId,
    ...getQueryOptions({ endpoint: "/groups", queryParams: { testId } }),
    select: (result) => {
      const group = result?.data.find((group) => group.id === groupId);
      return group;
    },
  });
};
